import type { ReactNode } from 'react';

interface MetaItemProps {
  label: ReactNode;
  children: ReactNode;
  className?: string;
}

/**
 * A label/value pair for detail panels.
 *
 * The two are separated on THREE axes at once — size (11px vs 15px), weight
 * (semibold caps vs semibold body) and colour (slate-600 vs slate-900) — plus
 * letter-spacing on the label. Relying on colour alone made them read as one
 * blob at a glance, and colour alone also fails for anyone with reduced colour
 * vision. The label is deliberately the quieter element: the value is the
 * content someone came to read.
 */
export function MetaItem({ label, children, className = '' }: MetaItemProps) {
  return (
    <div className={className}>
      <dt className="text-[11px] font-semibold uppercase leading-none tracking-[0.08em] text-slate-600">
        {label}
      </dt>
      <dd className="mt-1.5 text-[15px] font-semibold leading-snug text-slate-900">{children}</dd>
    </div>
  );
}
